import Cookies from 'js-cookie';
import { axios } from 'lib/axios';

export const passwordLogin = async (data) => {
  console.log(data)
  const response = await axios.post('/user/passwordLogin', data);
  console.log(response)
  let user;
  user = await handleLoginUserResponse(response);
  return user;
};

async function handleLoginUserResponse(data) {
  const { user } = data;
  Cookies.set('temp_token', user.token);
  return user;
}
